import { render, staticRenderFns } from "./HumanResourcesTable.vue?vue&type=template&id=3c658671&scoped=true&"
import script from "./HumanResourcesTable.vue?vue&type=script&lang=ts&"
export * from "./HumanResourcesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c658671",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
